import accountOrder from '#common/store/accountOrder'
import checkout from '#common/store/checkout'
import myCellar from '#common/store/myCellar'
import subscriptionGifting from '#common/store/subscriptionGifting'
import workGroupTracker from '#common/store/workGroupTracker'
import Vuex from 'vuex'
import allRegionsFilters from './modules/allRegionsFilters'
import cart from './modules/cart'
import checkoutState from './modules/checkoutState'
import futures from './modules/futures'
import homepageSearch from './modules/homepageSearch'
import notifications from './modules/notifications'
import pptoOrder from './modules/pptoOrder'
import pptoToast from './modules/pptoToast'
import product from './modules/product'
import promoBanner from './modules/promoBanner'
import restaurant from './modules/restaurant'
import savedSearch from './modules/savedSearch'
import search from './modules/search'
import serverInit from './modules/serverInit'
import wineClub from './modules/wineClub'

const store = () =>
  new Vuex.Store({
    modules: {
      workGroupTracker,
      cart,
      checkoutState,
      savedSearch,
      search,
      homepageSearch,
      restaurant,
      allRegionsFilters,
      accountOrder,
      serverInit,
      promoBanner,
      product,
      wineClub,
      subscriptionGifting,
      checkout,
      notifications,
      pptoToast,
      pptoOrder,
      myCellar,
      futures,
    },
  })

export default store
